module.exports = __webpack_public_path__ + "static/18-5fea3b0c32a9c7bc4c120076de88832d.jpg";